<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Approaching Pickup Message</ion-title>
        <ion-buttons slot="end">
            <ion-button id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
        <ion-list-header color="secondary" class="ion-text-wrap">
            Send this message to the ticket holder saying we are on our way to pick you up.
        </ion-list-header>

        <app-customer-messages 
            [config]="config" 
            [(data)]="vm" 
            [submitted]="submitted"
            (save)="onSaveClick()">
        </app-customer-messages>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick()" [disabled]="customerMessagesComponent?.form?.invalid"
            data-test="saveButton">Save</ion-button>
    </ion-toolbar>
</ion-footer>